import React from "react";
import LogoImage from "../../assets/LogoImage.png"

export default function Logo(){
  return <img src={LogoImage}  alt="Logo" width={67}/>
}